export default "__VITE_ASSET__9ebe6984__"